export const dataLayerPush = (layer) => {
  if (typeof window === 'undefined') {
    return;
  }
  window._mtm = window._mtm || [];
  window._mtm.push(layer);
};
